import Vue from 'vue';
import VueRouter from 'vue-router';
import TrackingPedido from '@/views/TrackingPedido.vue';
import NewCliente from '@/views/newCliente.vue';
import BuscadorEmpresa from '@/views/BuscadorEmpresa.vue';
Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'TrackingPedido',
      component: TrackingPedido,
    },
    // {
    //   path: '/newCliente',
    //   name: 'newCliente',
    //   component: NewCliente,
    // }, 
    {
      path: '/empresas',
      name: 'empresas',
      component: BuscadorEmpresa,
      query: {
        id: null,
        codigo: null,
        orden: null
      }    
    }, 
  ]
});

export default router;
